export const CLASS_NAMES = {
  baseSelect: "appearance-none w-full h-full opacity-0 absolute",
};

export const DEFAULT_VALUE = "";
